import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { AlertTriangle } from "lucide-react";
import type { ProductResponseDTO } from "@/features/products/types/product.types";
import { getProductTypeLabel } from "@/features/products/utils/product.utils";
import { ProductType } from "@/shared/types/enums";
import { memo } from "react";

interface ProductDeleteDialogProps {
  open: boolean;
  loading: boolean;
  product: ProductResponseDTO | null;
  onClose: () => void;
  onConfirm: () => void;
}

export const ProductDeleteDialog = memo(function ProductDeleteDialog({
  open,
  loading,
  product,
  onClose,
  onConfirm,
}: ProductDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Excluir Produto</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir este produto?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <div className="p-4 bg-destructive/10 rounded-md border border-destructive/20">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold">
                  {getProductTypeLabel(product?.type || ProductType.JACKET)} -{" "}
                  {product?.brand}
                </p>
                <p className="text-sm text-muted-foreground">
                  {product?.name || product?.color}
                </p>
                <p className="text-sm text-destructive mt-2">
                  Esta ação não pode ser desfeita!
                </p>
              </div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? "Excluindo..." : "Excluir Produto"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});
